/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Published_SuccessInputs */



/**
* | output |
* | --- |
* | "Caption file published successfully!" |
*
* @param {Ateliere_Connect_Caption_Published_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_published_success = /** @type {((inputs?: Ateliere_Connect_Caption_Published_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Published_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de sous-titres publié avec succès !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei erfolgreich veröffentlicht!")
	if (locale === "it") return /** @type {LocalizedString} */ ("File didascalia pubblicato con successo!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл с подписью успешно опубликован!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡El archivo de subtítulos se publicó correctamente!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕文件发布成功！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションファイルが正常に公開されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन फाइल सफलतापूर्वक प्रकाशित हो गई!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de legenda publicado com sucesso!")
	return /** @type {LocalizedString} */ ("Caption file published successfully!")
});